import { render, staticRenderFns } from "./PriceDisplay.vue?vue&type=template&id=7591fac6&scoped=true"
import script from "./PriceDisplay.vue?vue&type=script&lang=ts"
export * from "./PriceDisplay.vue?vue&type=script&lang=ts"
import style0 from "./PriceDisplay.vue?vue&type=style&index=0&id=7591fac6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7591fac6",
  null
  
)

export default component.exports